package com.narbase.letsgo.web.views.admin.contactUs

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.config.ConfigDto
import com.narbase.letsgo.web.dto.config.ContactDto
import com.narbase.letsgo.web.dto.config.ContactUsConfigDto
import com.narbase.letsgo.web.dto.config.copyX
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.incentives.GetConfigEndpoint
import com.narbase.letsgo.web.routing.domain.admin.incentives.UpsertConfigEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class ContactUsManagementViewModel {

    val upsertUiState = Observable<BasicUiState>()
    val getConfigUiState = Observable<BasicUiState>()

    var config: ConfigDto? = null
    var data: ContactUsConfigDto? = null

    var pageNo = 0
    var pageSize = 20
    var total = 0

    fun getConfig() {
        setUpsertUiStateToNull()
        basicNetworkCall(getConfigUiState) {
            val dto = GetConfigEndpoint.Request()
            val response = GetConfigEndpoint.remoteProcess(dto).data
            config = response.data
            data = response.data?.contactUsConfigDto
        }
    }

    fun editItem(contact: ContactDto) {
        val configDto = config ?: return
        val contactUsConfig = configDto.contactUsConfigDto
        val existingContact = contactUsConfig.contacts.find { it.id == contact.id }
        val existingIds = contactUsConfig.contacts.map { it.id }
        val newId = generateNewContactId(existingIds)
        val updatedList =
            if (existingContact != null) contactUsConfig.contacts.map { if (it.id == existingContact.id) contact else it } else contactUsConfig.contacts.toList()
                .plus(contact.copyX(id = newId))
        val updatedContactConfig = ContactUsConfigDto(
            updatedList.toTypedArray()
        )
        val updateConfig = ConfigDto(
            callCenterConfig = configDto.callCenterConfig,
            orderingIncentiveConfig = configDto.orderingIncentiveConfig,
            timeoutIncentiveConfig = configDto.timeoutIncentiveConfig,
            ipLockingConfig = configDto.ipLockingConfig,
            targetConfig = configDto.targetConfig,
            contactUsConfigDto = updatedContactConfig,
            smsConfigDto = configDto.smsConfigDto,
            termsAndConditionsConfigDto = configDto.termsAndConditionsConfigDto
        )
        basicNetworkCall(upsertUiState) {
            val dto = UpsertConfigEndpoint.Request(updateConfig)
            UpsertConfigEndpoint.remoteProcess(dto).data
        }
    }

    fun deleteItem(contactId: Int) {
        val configDto = config ?: return
        val contactUsConfig = configDto.contactUsConfigDto
        val updatedList =
            contactUsConfig.contacts.toMutableList()
        updatedList.removeAll { it.id == contactId }
        val updatedContactConfig = ContactUsConfigDto(
            updatedList.toTypedArray()
        )
        val updateConfig = ConfigDto(
            callCenterConfig = configDto.callCenterConfig,
            orderingIncentiveConfig = configDto.orderingIncentiveConfig,
            timeoutIncentiveConfig = configDto.timeoutIncentiveConfig,
            ipLockingConfig = configDto.ipLockingConfig,
            targetConfig = configDto.targetConfig,
            contactUsConfigDto = updatedContactConfig,
            smsConfigDto = configDto.smsConfigDto,
            termsAndConditionsConfigDto = configDto.termsAndConditionsConfigDto
        )
        basicNetworkCall(upsertUiState) {
            val dto = UpsertConfigEndpoint.Request(updateConfig)
            UpsertConfigEndpoint.remoteProcess(dto)
        }
    }

    private fun generateNewContactId(existingIds: List<Int?>): Int {
        return (existingIds.toMutableList().maxOfOrNull { it ?: -1 } ?: 0) + 1
    }

    fun setUpsertUiStateToNull() {
        upsertUiState.value = null
    }
}